import Swiper from "swiper/bundle";

export default function initSwiper() {
  const header = document.querySelector('.header');
  const slider = document.querySelector('[data-slider]')
  const dataSliderImage = document.querySelector('[data-slider-image]');
  const dataSliderImageGallery = document.querySelector('[data-slider-image-gallery]');
  const brandSlider = document.querySelector("[data-brand-slider]");

  if (brandSlider) {
    new Swiper("[data-brand-slider]", {
      slidesPerView: 3,
      freeMode: {
        enabled: true,
        momentum: false,
      },
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 6
        },
        1024: {
          slidesPerView: 7
        }
      }
    })

  }

  if (slider) {
    console.log("data-slider");
    new Swiper("[data-slider]", {
      pagination: {
        clickable: true,
        el: ".swiper-pagination",
      },
      on: {
        init: (swiper) => {
          setSlideStyle(swiper);
        },
        slideChange: (swiper) => {
          setSlideStyle(swiper);
        }
      }
    })
  }

  if (dataSliderImage) {
    new Swiper("[data-slider-image]", {
      loop: true,
      speed: 800,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      slidesPerView: 1,
      centeredSlides: true,
      breakpoints: {
        768: {
          slidesPerView: 3,
          centeredSlides: false,
        },
        1300: {
          slidesPerView: 4,
          centeredSlides: false,
        },
      }
    })
  }
  if(dataSliderImageGallery){
    new Swiper("[data-slider-image-gallery]",{
      slidesPerView: 1,
      effect: "slide",
      fadeEffect: {
        crossFade: true
      },
      speed: 1000,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      breakpoints: {
        1024: {},
      },
    });

  }
}

function setSlideStyle(swiper) {
  const activeSlide = swiper.slides[swiper.activeIndex];
  const wrapper = swiper.slidesEl.closest('.about-slider__wrapper');
  if (!wrapper) return;

  if (header.hasAttribute('data-slider-header')) {
    header.dataset.logo = activeSlide?.dataset.setLogo || '';
  }

  wrapper.style.backgroundColor = activeSlide?.dataset.setBg || '';
  document.documentElement.style.setProperty('--header-bg', activeSlide?.dataset.setBg || '');
  document.documentElement.style.setProperty('--about-slide-decor-color', activeSlide?.dataset.decorColor || '');
  document.documentElement.style.setProperty('--about-slide-primary-color', activeSlide?.dataset.primaryColor || '');
  document.documentElement.style.setProperty('--about-slide-secondary-color', activeSlide?.dataset.secondaryColor || '');
  document.documentElement.style.setProperty('--about-slide-pagination-color', activeSlide?.dataset.paginationColor || '');
}
